import { Component, OnInit, ViewChild } from '@angular/core';
import Api from 'app/helpers/api';
import App from 'app/helpers/app';
import Me from 'app/helpers/me';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import { CountdownComponent } from 'ngx-countdown';
import * as moment from 'moment';

@Component({
  selector: 'app-first-onboarding',
  templateUrl: './first-onboarding.component.html',
  styleUrls: ['./first-onboarding.component.scss']
})
export class FirstOnboardingComponent implements OnInit {
  @ViewChild('cd', { static: false }) private countdown: CountdownComponent;

  user = null

  countdownTimeUnits: Array<[string, number]> = [
    ['Y', 1000 * 60 * 60 * 24 * 365], // years
    ['M', 1000 * 60 * 60 * 24 * 30], // months
    ['D', 1000 * 60 * 60 * 24], // days
    ['H', 1000 * 60 * 60], // hours
    ['m', 1000 * 60], // minutes
    ['s', 1000], // seconds
    ['S', 1], // million seconds
  ];
  configTimer = {
    leftTime: 0,
    formatDate: ({ date, formatStr }) => {
      let duration = Number(date || 0);

      return this.countdownTimeUnits.reduce((current, [name, unit]) => {
        if (current.indexOf(name) !== -1) {
          const v = Math.floor(duration / unit);
          duration -= v * unit;
          return current.replace(new RegExp(`${name}+`, 'g'), (match: string) => {
            return v.toString().padStart(match.length, '0');
          });
        }
        return current;
      }, formatStr);
    },
  }


  constructor(private api: Api,
    private app: App,
    private spinner: NgxSpinnerService,
    private me: Me,
    ) {

   
  }

  async ngOnInit() {

    const self = this

    this.user = await this.me.get(false).pipe(take(1)).toPromise()
  

    if(self.user && self.user.firstOnboardingProgress==null){
      self.user.firstOnboardingProgress = 1
      self.me.onboardingUpdate(self.user)
    }
    
    self.configTimer.leftTime = moment().add(30, 'minutes').diff(moment(), "seconds")
    setTimeout(() => { if (this.countdown) { console.log("tinha countdown"); this.countdown.begin() } }, 500)

  }

  async updateOnboardingProgress(step, customers, goCheckout){
    const self = this
    console.log(step)

    if(goCheckout==true){
      self.user.initiateCheckoutOnboarding = true
    }

    if(customers){
      self.user.customersAmount = customers  
    }

    self.user.firstOnboardingProgress = step
    self.me.onboardingUpdate(self.user)

    if(goCheckout==true){
      window.location.href="https://opersonaldigital.com.br/oferta-boas-vindas"
    }

    if(step==5){
      window.location.href="https://app.opersonaldigital.com.br/page?ontour=1"
    }
  }
  
  cancelarWhatsApp(){
    const self = this

    self.user.onboardingInviteCustomer = true
    self.me.onboardingUpdate(self.user)

    window.open(`https://api.whatsapp.com/send?text=Tenho uma ótima notícia pra você! A partir de agora você receberá seus treinos através do meu app, bastar clicar no link para baixar e realizar seu cadastro: ${this.user.inviteLink}.`, "_blank");
  }

}
